import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, type SegmentedOptions } from 'ui';
import type { Layout } from '../../../../types';

export const useGetLayoutOptions = (): SegmentedOptions<Layout> => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { icon: <Icon icon="grid-line" size="extra-small" />, tooltip: { title: t('Calendar') }, value: 'calendar' },
      { icon: <Icon icon="list-check-line" size="extra-small" />, tooltip: { title: t('Agenda') }, value: 'agenda' },
    ],
    [t],
  );
};
